import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import { LINKS } from '@/constants/links';
import { Button } from '@/components/buttons';
import { useTranslation } from 'react-i18next';
import { CalculatorForm } from './CalculatorForm';
import { Modal } from '@/components/modal';
import { formatAmount, formatNum } from '@/utils/formatting';
import { Language } from '@/constants/currencyConfig';
import { calculatePostponeDueDateValues, PostponeDueDateCalculatorResult } from './calculatorValues';
import { CalculatorResultRow } from '@/components/CalculatorResultRow';
const MONTH_SPENDINGS_MAX = 100000;
const MONTH_SPENDINGS_MIN = 1000;
const DEFAULT_MONTH_SPENDINGS = MONTH_SPENDINGS_MAX / 2;
const DEFAULT_CURRENT_PAYMENT = DEFAULT_MONTH_SPENDINGS / 20;
export function Calculator() {
  const $ = _c(89);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = calculatePostponeDueDateValues(DEFAULT_MONTH_SPENDINGS, DEFAULT_CURRENT_PAYMENT);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [calculatorValues, setCalculatorValues] = useState(t0);
  const [isModalOpened, setIsModalOpened] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["postponeDueDate"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t,
    i18n
  } = useTranslation(t1);
  let t2;
  if ($[2] !== i18n.language) {
    t2 = value => `${formatNum(value, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }, i18n.language) ?? "0.00"} %`;
    $[2] = i18n.language;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formatPercentage = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t4 => {
      const {
        currentPayment,
        monthSpendings
      } = t4;
      setCalculatorValues(calculatePostponeDueDateValues(monthSpendings, currentPayment));
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const calculateDefermentFee = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsModalOpened(false);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("calculator.example.title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <h2 className="mb-6 text-xl font-semibold">{t5}</h2>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("calculator.example.text.1");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <p className="mb-4 text-sm sm:text-base">{t7}</p>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("calculator.example.subtitle.1");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <h3 className="mb-1 text-sm font-semibold sm:text-base">{t9}</h3>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("calculator.example.text.2");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <p className="mb-4 text-sm sm:text-base">{t11}</p>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t("calculator.example.subtitle.2");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13) {
    t14 = <h3 className="mb-1 text-sm font-semibold sm:text-base">{t13}</h3>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t) {
    t15 = t("calculator.example.text.3");
    $[26] = t;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = <p className="mb-4 text-sm sm:text-base">{t15}</p>;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t("calculator.example.text.4");
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = <p className="text-sm"><i>{t17}</i></p>;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isModalOpened || $[35] !== t10 || $[36] !== t12 || $[37] !== t14 || $[38] !== t16 || $[39] !== t18 || $[40] !== t6 || $[41] !== t8) {
    t19 = <Modal isVisible={isModalOpened} onClose={t4} modalName="postponeDueDateCalculatorExample" analyticsParam="postponeDueDateCalculatorExample" testId="postponeDueDateCalculatorExample" className="max-w-[48rem] rounded-4xl p-10">{t6}{t8}{t10}{t12}{t14}{t16}{t18}</Modal>;
    $[34] = isModalOpened;
    $[35] = t10;
    $[36] = t12;
    $[37] = t14;
    $[38] = t16;
    $[39] = t18;
    $[40] = t6;
    $[41] = t8;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <CalculatorForm monthSpendingsMax={MONTH_SPENDINGS_MAX} monthSpendingsMin={MONTH_SPENDINGS_MIN} onChange={calculateDefermentFee} />;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t) {
    t21 = t("calculator.answer");
    $[44] = t;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  const t22 = i18n.language as Language;
  let t23;
  if ($[46] !== calculatorValues.defermentFee || $[47] !== t22) {
    t23 = formatAmount(calculatorValues.defermentFee, t22);
    $[46] = calculatorValues.defermentFee;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t21 || $[50] !== t23) {
    t24 = <CalculatorResultRow highlighted={true} title={t21} value={t23} />;
    $[49] = t21;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t) {
    t25 = t("calculator.annualInterestRate");
    $[52] = t;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  const t26 = formatPercentage(calculatorValues.annualInterestRate);
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = <CalculatorResultRow title={t25} value={t26} />;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t) {
    t28 = t("calculator.rpsn");
    $[57] = t;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  const t29 = formatPercentage(calculatorValues.rpsn);
  let t30;
  if ($[59] !== t28 || $[60] !== t29) {
    t30 = <CalculatorResultRow title={t28} value={t29} />;
    $[59] = t28;
    $[60] = t29;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = LINKS();
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  const t32 = t31.registration;
  let t33;
  if ($[63] !== t) {
    t33 = t("calculator.cta");
    $[63] = t;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== t33) {
    t34 = <Button to={t32} testId="postponeDueDateRegistration" analyticsParam="postponeDueDateRegistration" size="lg" variant="primary" align="center" className="mt-6 mb-3 max-w-full md:hidden lg:mt-0">{t33}</Button>;
    $[65] = t33;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t24 || $[68] !== t27 || $[69] !== t30 || $[70] !== t34) {
    t35 = <div className="mt-12 mb-4 flex flex-col gap-3 rounded-2xl bg-blue-500 p-6 text-white md:mb-12">{t24}{t27}{t30}{t34}</div>;
    $[67] = t24;
    $[68] = t27;
    $[69] = t30;
    $[70] = t34;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = LINKS();
    $[72] = t36;
  } else {
    t36 = $[72];
  }
  const t37 = t36.registration;
  let t38;
  if ($[73] !== t) {
    t38 = t("calculator.cta");
    $[73] = t;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] !== t38) {
    t39 = <Button to={t37} testId="postponeDueDateRegistration" analyticsParam="postponeDueDateRegistration" size="lg" variant="primary" align="center" className="mb-3 hidden md:block">{t38}</Button>;
    $[75] = t38;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = () => setIsModalOpened(true);
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== t) {
    t41 = t("calculator.example.cta");
    $[78] = t;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  if ($[80] !== t41) {
    t42 = <div className="text-center"><Button variant="unstyled" onClick={t40} testId="postponeDueDateCalculatorExample" analyticsParam="postponeDueDateCalculatorExample" align="center" className="text-gray-900 underline">{t41}</Button></div>;
    $[80] = t41;
    $[81] = t42;
  } else {
    t42 = $[81];
  }
  let t43;
  if ($[82] !== t35 || $[83] !== t39 || $[84] !== t42) {
    t43 = <div className="mx-auto max-w-[60.5rem] rounded-2xl bg-blue-100 p-4 text-gray-900 md:rounded-[2.5rem] md:p-12 md:pt-14">{t20}{t35}{t39}{t42}</div>;
    $[82] = t35;
    $[83] = t39;
    $[84] = t42;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  let t44;
  if ($[86] !== t19 || $[87] !== t43) {
    t44 = <div className="px-2">{t19}{t43}</div>;
    $[86] = t19;
    $[87] = t43;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  return t44;
}